exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  position: absolute;\n  z-index: 2000;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  bottom: 0px;\n  padding: 10px; }\n\n.ngx-gallery-bullet {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  cursor: pointer;\n  background: #9c9b99; }\n  .ngx-gallery-bullet:not(:first-child) {\n    margin-left: 5px; }\n  .ngx-gallery-bullet:hover, .ngx-gallery-bullet.ngx-gallery-active {\n    background: white; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/ngx-gallery/ngx-gallery-bullets.component.scss
// module id = ../../../../../src/app/components/ngx-gallery/ngx-gallery-bullets.component.scss
// module chunks = main